import { AppProps, DeviceType } from '@redbubble/next/types';
import { usePageProps } from '@redbubble/next-provider';
import { SearchResultsPageProps } from '../pages/shop/types';

const itemsInViewByDeviceType = Object.freeze({
  [DeviceType.Mobile]: 2,
  [DeviceType.Desktop]: 6,
});

export const useSRPImagePreloadLimits = (initialDeviceType: DeviceType) => {
  const { heroData } = usePageProps<SearchResultsPageProps & AppProps>();
  if (heroData?.image) return 0;

  return (
    itemsInViewByDeviceType[initialDeviceType] ??
    itemsInViewByDeviceType[DeviceType.Mobile]
  );
};
